import $ from 'jquery';
import smoothScroll from 'jquery-smooth-scroll'

export default {
    init () {
      if ($('.page-template-tpl-support-topic')) {
        $('.support-sidebar-expandable.open .support-sidebar-link:first').addClass('active');
        $('.faq-group-section').hide();
        $('.faq-group-section:first').show();
      }

      //prevent auto scroll to on empty # troughout the site
      $("a[href=\\#]").attr("href","javascript:void(0)");

      var scrollnow = function(e) {
        // if scrollnow()-function was triggered by an event
        let target;
        let offset;

        [...document.querySelectorAll('.js-scroll')].forEach(item => {
          item.classList.remove('active')
        })

        if (e) {
          e.preventDefault();
          target = this.hash;
          offset = -100
        } else {
          // else it was called when page with a #hash was loaded
          target = location.hash;
          offset = -100
        }

        document.querySelector(`.js-scroll[href="${target}"]`).classList.add('active')

        $.smoothScroll({
          offset: offset,
          scrollTarget: target
        });
      };

      // if page has a #hash
      if (location.hash) {
        $('html, body').scrollTop(0).show();
        // smooth-scroll to hash
        scrollnow();
      }

      // for each <a>-element that contains a "/" and a "#"
      $('a[href*="/"][href*="#"]').each(function(){
        // if the pathname of the href references the same page
        if (this.pathname.replace(/^\//,'') == location.pathname.replace(/^\//,'') && this.hostname == location.hostname) {
          // only keep the hash, i.e. do not keep the pathname
          $(this).attr("href", this.hash);
        }
      });

      // select all href-elements that start with #
      // including the ones that were stripped by their pathname just above
      $('a.js-scroll').click(scrollnow);

      // on user scrolling in window function
      $(window).scroll(function() {
      var scrollDistance = $(window).scrollTop();
      // Assign active class to nav links while scrolling past corresponding faq-sections
      $('.faq-section').each(function(i) {
      var top = $(this).position().top - document.querySelector('header').clientHeight
          if (top <= scrollDistance) {
            $('.support-sidebar-expandable.open .support-sidebar-link').eq(i).parent().siblings().children().removeClass('active');
            $('.support-sidebar-expandable.open .support-sidebar-link').eq(i).addClass('active');
        }
      });
    })

  }
}
